<template>
    <div class="ts-p-3">
        <div class="ts-overflow-y-scroll max-h">
            <table class="ts-w-full">
                <thead>
                    <tr>
                        <th class="ts-text-center" style="width: 3%">{{ $t('purchaseOrder.numberRow') }}</th>
                        <th style="width: 15%">{{ $t('purchaseRequestTemplate.productGroup') }}</th>
                        <th style="width: 15%">{{ $t('purchaseRequestTemplate.barcode') }}</th>
                        <th style="width: 25%">{{ $t('purchaseRequestTemplate.productName') }}</th>
                        <th class="ts-text-center" style="width: 10%">{{ $t('purchaseRequestTemplate.uom') }}</th>
                        <th class="ts-text-center" style="width: 10%">{{ $t('purchaseRequestTemplate.quantity') }}</th>
                        <th class="ts-text-center" style="width: 10%">{{ $t('purchaseRequestTemplate.unitPrice') }}</th>
                        <th style="width: 15%">{{ $t('purchaseRequestTemplate.remarks') }}</th>
                        <th class="ts-text-center" style="width: 3%"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="model.details.length == 0">
                        <td colspan="9" class="ts-text-center ts-p-5">
                            <div class="ts-flex ts-flex-col ts-items-center ts-justify-center ts-py-10">
                                <div class="ts-mb-4">
                                    <i class="fa fa-shopping-cart ts-text-gray-300" style="font-size: 4rem;"></i>
                                </div>
                                <h4 class="ts-text-xl ts-font-semibold ts-text-gray-600 ts-mb-2">{{
                                    $t('purchaseRequestTemplate.noItems') }}</h4>
                                <p class="ts-text-gray-500 ts-mb-4">{{ $t('purchaseRequestTemplate.clickToAdd') }}</p>
                                <div class="validate ts-text-red-500" v-if="errors.has('details')">
                                    {{ errors.first('details') }}
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr v-for="(d, index) in model.details" :key="index">
                        <td class="ts-text-center">
                            {{ index + 1 }}
                        </td>
                        <td>
                            <input type="text" class="form-control"
                                :value="findProduct(d.product_id) ? findProduct(d.product_id).pro_group_name_en : ''"
                                readonly />
                        </td>
                        <td>
                            <input type="text" class="form-control"
                                :value="findProduct(d.product_id) ? findProduct(d.product_id).barcode : ''" readonly />
                        </td>
                        <td>
                            <input type="text"
                                :value="findProduct(d.product_id) ? findProduct(d.product_id).product_name_en : ''"
                                class="form-control" readonly style="min-width: 200px" />
                        </td>
                        <td>
                            <a-select v-model="d.uom_id" class="ts-w-full" style="min-width: 70px"
                                :options="getUnitOfMeasures(findProduct(d.product_id) ? findProduct(d.product_id).uom_cat_id : null)"
                                option-filter-prop="children" :class="{
                                    'is-invalid': errors.has('details.' + index + '.uom_id')
                                }">
                            </a-select>
                        </td>
                        <td>
                            <input v-model.number="d.quantity" type="number" class="form-control ts-text-center" :class="{
                                'is-invalid': errors.has('details.' + index + '.quantity')
                            }" style="min-width: 70px" min="1" />
                            <div class="validate" v-if="errors.has('details.' + index + '.quantity')">
                                {{ errors.first('details.' + index + '.quantity') }}
                            </div>
                        </td>
                        <td>
                            <input v-model.number="d.unit_price" type="number" class="form-control ts-text-right"
                                style="min-width: 100px" min="0" step="0.01" />
                        </td>
                        <td class="ts-whitespace-no-wrap">
                            <textarea v-model="d.remarks" class="form-control" style="min-width: 150px; width: 100%"
                                rows="1" placeholder="Remarks"></textarea>
                        </td>
                        <td style="min-width: 35px" class="ts-text-center">
                            <a href="#" class="ts-text-red-700 hover:ts-text-red-700"
                                @click.prevent="removeItem(index)">
                                <i class="fa fa-trash"></i>
                            </a>
                        </td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr class="total-footer">
                        <td colspan="5">
                            <b>{{ $t('purchaseRequestTemplate.totalItems') }}: {{ model.details.length }}</b>
                        </td>
                        <td class="ts-text-center">
                            <b>{{ sumTotalQty }}</b>
                        </td>
                        <td colspan="3"></td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'

export default {
    name: 'itemList',
    props: ['value', 'validate'],
    data() {
        return {
            errors: new Errors(),
            model: {}
        }
    },
    created() {
        this.model = this.value
    },
    computed: {
        ...mapState('purchaseRequest/template', ['formViewDatas']),
        products() {
            if (this.formViewDatas['products']) {
                return this.formViewDatas['products']
            }
            return []
        },
        unitOfMeasures() {
            if (this.formViewDatas['unitOfMeasures']) {
                return this.formViewDatas['unitOfMeasures'].map(el => ({
                    value: el.uom_id,
                    label: el.uom_name_en,
                    uom_cat_id: el.uom_cat_id,
                    is_default: el.is_default
                }))
            }
            return []
        },
        sumTotalQty() {
            return this.model.details.reduce((sum, item) => sum + (item.quantity || 0), 0)
        }
    },
    methods: {
        findProduct(product_id) {
            return this.products.find(p => p.product_id == product_id)
        },
        getUnitOfMeasures(uom_cat_id) {
            return this.unitOfMeasures.filter(el => el.uom_cat_id == uom_cat_id)
        },
        removeItem(index) {
            this.model.details.splice(index, 1)
        }
    },
    watch: {
        validate: function (error) {
            this.errors = new Errors(error.errors)
        }
    }
}
</script>

<style scoped>
.max-h {
    min-height: 40vh;
    max-height: 60vh;
    overflow-y: scroll;
}

.form-control {
    height: 32px;
}

table {
    width: 100%;
}

table thead tr {
    border-width: 1px;
    z-index: 3;
    position: sticky;
    top: 0;
}

table thead tr th {
    white-space: nowrap;
    background-color: #edf2f7;
    padding-left: 0.25rem;
    padding-right: 0.25rem;
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
}

table tbody tr {
    border-width: 1px;
}

table tbody tr td {
    white-space: nowrap;
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
    padding-left: 0.25rem;
    padding-right: 0.25rem;
    border-right-width: 1px;
}

table tfoot tr.total-footer {
    background-color: #edf2f7;
    font-weight: bold;
}

table tfoot tr.total-footer td {
    padding: 0.5rem;
}
</style>
